export default "__VITE_ASSET__D1zXqLYT__"